import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getGlobalClasses = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/global-class`);
    return response.data;
  } catch (error) {
    console.error('Error fetching global classes:', error.response?.data || error);
    throw error;
  }
};

export const getGlobalClassById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/global-class/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching global class:', error.response?.data || error);
    throw error;
  }
};

export const createGlobalClass = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/global-class`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating global class:', error.response?.data || error);
    throw error;
  }
};

export const updateGlobalClass = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/global-class/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating global class:', error.response?.data || error);
    throw error;
  }
};

export const deleteGlobalClass = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/global-class/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting global class:', error.response?.data || error);
    throw error;
  }
};
